// extracted by mini-css-extract-plugin
export var blockManagementTabs = "ManagementTabs-module--block-management-tabs--1rMsm";
export var leaderWrapper = "ManagementTabs-module--leaderWrapper--1iFDO";
export var nameTitleWrapper = "ManagementTabs-module--nameTitleWrapper--1Ywk_";
export var peopleHeadshot = "ManagementTabs-module--peopleHeadshot--9TQoG";